export default class Selected {
  public affairs: number[] = [];
  public sessions: number[] = [];
  public category: string | null = null;
  public groups: string[] = [];
  public protocols: string[] = [];
  public columns: string[] = [];
  public columnCategories: string[] = [];
  public fields: string[] = [];
}
